import type { FC } from "react";

import type { CardGalleryCardGalleryItems } from "~/core";
import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";
import { Button, Image, Markdown, useUiKitComponents } from "~/shared/ui-kit";
import { Card } from "~/shared/ui-kit/card/Card";
import { Flex } from "~/shared/ui-kit/flex/Flex";

import type { CardGalleryProps } from "../CardGallery";

export type RowCardProps = Omit<CardGalleryProps, "data"> & {
  card?: CardGalleryCardGalleryItems;
};
export const RowCard: FC<RowCardProps> = (props) => {
  const {
    card: data,
    getImageUrl,
    getUrl,
    isControlInactive,
    onCallAction,
  } = props;
  const { Link } = useUiKitComponents();
  const controlAction = data?.card_gallery_items_id?.button_action;
  const isInactive = controlAction ? isControlInactive(controlAction) : true;
  const action = data?.card_gallery_items_id?.button_action?.action?.[0];
  let href;
  if (isExternalLink(action?.item)) {
    href = action.item.href ?? undefined;
  }
  if (isInternalLink(action?.item)) {
    href = action.item.page ? getUrl(action.item.page) : undefined;
  }
  const handlePressButton = (): void => {
    if (action) {
      onCallAction(action);
    }
  };

  return (
    <Card variant="primary" className="max-w-[400px]">
      <Flex flexDirection="column" className="h-full">
        <Link href={href}>
          <Image
            value={getImageUrl(data?.card_gallery_items_id?.image?.id ?? "", {
              format: "webp",
              height: 205,
            })}
            mdValue={getImageUrl(data?.card_gallery_items_id?.image?.id ?? "", {
              format: "webp",

              height: 250,
            })}
            className="rounded-t-lg h-fit  overflow-hidden block"
          />
        </Link>

        {data?.card_gallery_items_id?.text && (
          <Flex className="md:p-8 py-6 flex-grow">
            <Markdown>{data.card_gallery_items_id.text}</Markdown>
          </Flex>
        )}
        {!isInactive && (
          <Flex flexDirection="column" className="mt-auto">
            <Button
              href={href}
              weight="bold"
              size="small"
              className="py-3 px-6  md:mx-8 mb-6 md:mb-8 "
              onPress={handlePressButton}
            >
              {data?.card_gallery_items_id?.button_text}
            </Button>
          </Flex>
        )}
      </Flex>
    </Card>
  );
};
